import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 no-underline">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-shield-flash-line text-lg text-white"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed">
              {siteInfo.tagline}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-300 hover:text-primary-400 text-sm transition-colors no-underline"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              更多分类
            </h4>
            <ul className="space-y-2">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-foreground-300 hover:text-primary-400 text-sm transition-colors no-underline"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-foreground-300 hover:text-primary-400 text-sm transition-colors no-underline"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-foreground-300 hover:text-primary-400 text-sm transition-colors no-underline"
                >
                  联系我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-foreground-400 hover:text-primary-400 text-xs transition-colors no-underline"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-foreground-400 hover:text-primary-400 text-xs transition-colors no-underline"
              rel="nofollow"
            >
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}